import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

class OrganizationEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "Organization";
        this.primaryEnterpriseComponent = "Organization";

        let eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "Organization";
        eom.enterpriseComponent = "Organization";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "OrganizationPosition";
        eom.enterpriseComponent = "OrganizationPosition";
        eom.relationship = "OrganizationOrganizationPosition";
        this.enterpriseComponentMembers.set(eom.name, eom);

    }
}

export default OrganizationEnterpriseObjectMetadata;